
import Leyora91 from './Leyora 9.webp'
import Leyora92 from './Leyora 9.webp'


const Leyora9images =[
Leyora91,Leyora92
]

export default Leyora9images;